import { IDemoFlow, performed, proposal, ruleTarget, step } from './types';

// The Deactivate C-flow mirrored; no Figma frame draws Activate.

export const ACTIVATE_RULE_FLOWS: IDemoFlow[] = [
  {
    id: 'activate',
    prompt: 'Activate rule Summer Points',
    reply: now => ({
      outcome: 'action_proposed',
      answer: 'I will activate the Rule Summer Points (Rule ID: 640). Shall I proceed?',
      action: proposal(
        step(
          'activate_transaction_rule',
          'Activate Rule',
          ruleTarget(640, 'Summer Points', 'inactive')
        ),
        now
      )
    }),
    confirm: action => ({
      outcome: 'action_performed',
      answer: 'Activated the Rule Summer Points (Rule ID: 640).',
      action: performed(action, { id: 640, state: 'active' })
    })
  }
];
